// src/utils/is-client.ts
var IS_CLIENT = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var is_client_default = IS_CLIENT;

// src/import-for-display.ts
var resolver;
if (is_client_default) {
  resolver = new Promise((resolve) => {
    if (document.readyState === "interactive") {
      resolve();
    } else {
      const callback = () => {
        if (document.readyState === "interactive") {
          resolve();
          document.removeEventListener("readystatechange", callback, false);
        }
      };
      document.addEventListener("readystatechange", callback, false);
    }
  });
}
async function importForDisplay() {
  if (resolver != null) {
    await resolver;
  }
}

// src/import-for-interactive.ts
var resolver2;
if (is_client_default) {
  resolver2 = new Promise((resolve) => {
    if (document.readyState === "complete") {
      resolve();
    } else {
      const callback = () => {
        if (document.readyState === "complete") {
          resolve();
          document.removeEventListener("readystatechange", callback, false);
        }
      };
      document.addEventListener("readystatechange", callback, false);
    }
  });
}
async function importForInteractive() {
  if (resolver2 != null) {
    await resolver2;
  }
}

// src/import-for-next-frame.ts
async function importForNextFrame() {
  if (is_client_default) {
    await new Promise((resolve) => {
      requestAnimationFrame(() => {
        resolve();
      });
    });
  }
}

// src/import-for-timeout.ts
async function importForTimeout(ms) {
  if (is_client_default) {
    await new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }
}
export {
  importForDisplay,
  importForInteractive,
  importForNextFrame,
  importForTimeout
};
//# sourceMappingURL=index.js.map
